var exports = {
  "G": "x112a1f60--f028a5--social-links",
  "W": "x112a1f60--f028a5--input-link",
  "vk": "x112a1f60--f028a5--vk",
  "ok": "x112a1f60--f028a5--ok",
};

module.exports = exports;
